import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { DatasService } from '../../shared/services/datas.service'

import { LanguageService } from '../../shared/services/language.service';

import { TranslateService } from '@ngx-translate/core';

import { AccountService } from '../../shared/services/account.service';
import { ContactService } from '../../shared/services/contact.service';

import { Router, ActivatedRoute } from '@angular/router';import { RegisterSettingService } from '../../shared/services/register-setting.service'

import { getName } from '../../shared/thirdparty/countries/countries'

declare var $: any;
import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit, OnDestroy {
    /*

    Comment "window.Suggestions = module.exports = Suggestions;" on `node_modules/suggestions/index.js`

    */

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.defineTeamMembers()
    }

    public map = null
    public displayMap = isBrowser()
    public mapDots = {ifOffices: [], clients : []}

    mapCenter = [2.4330880641937256,46.768646240234375]

    public contactFormHiddenInputs = []
    public prefillFields = []
    displayedCountry = null

    public ifOffices = [
        {
            name : this.translate.instant("Registered office & administrative HQ"),
            fcts : [
                this.translate.instant("Commercial"),
                this.translate.instant("Consulting"),
                this.translate.instant("Marketing"),
                this.translate.instant("Administratif"),
            ],
            addr : "7 rue Léo Delibes",
            cp : 75116,
            city : "Paris",
            country : "France",
            tel : "+33179737979"
        },
        {
            name : this.translate.instant("VR expertise - R&D"),
            fcts : [
                this.translate.instant("Innovation"),
                this.translate.instant("Consulting"),
                this.translate.instant("Commerce"),
            ],
            addr : "ZA Albipôle – Lieu-dit Jean Thomas",
            cp : 81150,
            city : "Terssac",
            country : "France",
        },
        {
            logos : [
                {
                    src : "assets/logo-reactiv",
                    href : "http://www.reactiv-formation.com/",
                    alt : "Logo of the Réactiv company",
                    title : "Réactiv"
                },
                {
                    src : "assets/logo-echangeformation",
                    href : "http://www.echangeformation.com/",
                    alt : "Logo of the Echange Formation company",
                    title : "Echange Formation"
                }
            ],
            name : this.translate.instant("Expertise QHSE"),
            fcts : [
                this.translate.instant("Audit"),
                this.translate.instant("Conseil"),
                this.translate.instant("Formation"),
            ],
            addr : "3 avenue Antoine Pinay",
            cp : 42400,
            city : "Saint Chamond",
            country : "France",
        }
    ]

    // https://github.com/gavinr/world-countries-centroids/blob/master/dist/countries.csv

    mapMode = "world"
    mapDotClicked = null

    public valueDatas = {}
    public recup = {"recup": ["employees","projects", "safety_days", "partner", "vr_formations"]}

    public certifications = [
        {
            src : "assets/certifications/cybervadis",
            width : "220px",
            name : "Cybervadis",
            isSVG: true,
        }
    ]

    public timeline = [
        {
            date : "08-2016",
            icon : 'home-regular',
            content : {
                fr : ['Création de l\'entreprise'],
                en : ['Creation of the company']
            }
        },
        {
            date : "12-2017",
            icon : 'key-regular',
            content : {
                fr : [
                    '14 clients',
                    '7 Formations VR disponibles'
                ],
                en : [
                    '14 customers',
                    '7 VR training exercices released'
                ]
            }
        },
        {
            date : "07-2018",
            icon : 'users-regular',
            content : {
                fr : [
                    'Sortie de la plus grande',
                    'plateforme de formations HSE en VR'
                ],
                en : [
                    'Release of the largest Platform of',
                    'HSE VR Training Exercices'
                ]
            }
        },
        {
            date : "12-2018",
            icon : 'rocket-regular',
            content : {
                fr : [
                    '50 clients',
                    '15 Formations VR',
                    '250 Safety days organisées sur site'
                ],
                en : [
                    '50 customers',
                    '15 VR training exercices',
                    '250 Onsite Safety Days'
                ]
            }
        },
        {
            date : "12-2019",
            icon : 'university-regular',
            content : {
                fr : [
                    'Levée de fond',
                    '100 clients',
                    '45 Formations VR',
                    '500 Safety days organisées sur site'
                ],
                en : [
                    'Capital fundraising',
                    '100 customers',
                    '45 VR training exercices',
                    '500 Onsite Safety Days'
                ]
            }
        },
        {
            date : "02-2020",
            icon : 'star-regular',
            content : {
                fr : [
                    'Plateforme multi-user',
                    'Formations HSE digitales',
                ],
                en : [
                    'Platform hosting Multi-users',
                    'Digital Health, Safety and',
                    'Environment Events/Training',
                ]
            }
        },
        {
            date : "09-2021",
            icon : 'chalkboard-teacher-solid',
            content : {
                fr : [
                    'La plateforme HSE peut maintenant être utilisée à distance au sein d’un véritable campus virtuel permettant l’organisation d’évènements et de formations HSE en ligne.',
                ],
                en : [
                    'The EHS platform can now be used remotely within a true virtual campus allowing the organization of online EHS events and training.',
                ]
            }
        },
        {
            date : "11-2021",
            icon : 'handshake-solid',
            content : {
                fr : [
                    'Acquisition des organismes de formation :',
                    '<a href="http://www.echangeformation.com/" target="_blank" class="ancre">Echange Formation</a> et <a href="http://www.reactiv-formation.com/" target="_blank" class="ancre">REACTIV’</a>',
                    '(30 ans d’expérience en',
                    'audit et formation QHSE).'
                ],
                en : [
                    'Acquisition of the training organisations:',
                    '<a href="http://www.echangeformation.com/" target="_blank" class="ancre">Echange Formation</a> and <a href="http://www.reactiv-formation.com/" target="_blank" class="ancre">REACTIV’</a>',
                    '(30 years of experience in',
                    'QEHS audit and training).'
                ]
            }
        }
    ]
    public timelineConfig: Object = {
        pagination: '.swiper-pagination',
        nextButton: '.right-arrow',
        prevButton: '.left-arrow',
        slidesPerView: 4,
        paginationClickable: true,
        spaceBetween: 0,
        autoplay: 10000,
        initialSlide : this.timeline.length-3,
        breakpoints: {
            576: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            }
        }
    };

    public teamMembers = []

    constructor(
        public datasService : DatasService,
        public contactService:ContactService,
        public translate : TranslateService,
        public language:LanguageService,
        public router : Router,
        public activatedRoute: ActivatedRoute,
        private accountService : AccountService
    ) { }

    ngOnInit() {

        this.initMap()
        this.getSquareDatas()
        this.getOurTeam()

        if(this.activatedRoute.snapshot.paramMap['params']['action'] && this.activatedRoute.snapshot.paramMap['params']['action']=='o'){
            this.showModalContact()
        }
        if(this.accountService.isLogged()){
            this.contactFormHiddenInputs = ['origin']
        }
        console.log('state', this.router)
        console.log(this.router.getCurrentNavigation())

        if(isBrowser()){
            if(window.history.state && window.history.state['prefillContact']){
                this.prefillFields = [{id: "message", value: window.history.state['prefillContact']}]
            }
        }
    }

    ngOnDestroy(){
        if(isBrowser()){
            $('.modal-backdrop').remove()
        }
    }


    // Map -----------------------------------------

    initMap(){
        if(isBrowser()){
            this.displayMap = true
            this.contactService.getMapDots()
            .then((res)=>{
                if(res && res['ifOffices'] && res['clients']){
                    this.mapDots = res
                    for(let dot of this.mapDots['clients']){
                        if(dot.iso){
                            dot.name = getName(dot.iso, this.language.lang)
                        }
                    }
                }
            })
            .catch((e)=>{})
        }
    }

    mapReady(event){
        this.map = event
    }

    clickOnDot(dot){
        this.showModalContact(dot)
        // this.map.easeTo({
        //     center: [dot.lng,dot.lat]
        // });
    }

    zoom(q){
        this.map.easeTo({
            zoom: this.map.getZoom()+q
        });
    }

    changeMapMode(mode){
        this.displayedCountry = null
        if(mode == 'europe'){
            this.map.easeTo({
                zoom: 4.5,
                center: this.mapCenter
            });
        }
        else{
            this.map.easeTo({
                zoom: 2.25,
                center: this.mapCenter
            });
        }
        this.mapMode = mode

    }


    // Datas -----------------------------------------

    getSquareDatas(){
        this.datasService.getAllDatas(this.recup)
        .then((listDatas)=> {
            this.valueDatas = listDatas || {}
        })
        .catch((e)=>{
            this.valueDatas = {}
        })
    }


    // Our Team -----------------------------------------

    getOurTeam(){
        this.contactService.getTeams()
        .then((results)=> {
            var array = results;
            // Sort teams by position
            array.sort((a,b) => a.position - b.position);
            // Sort team members by position
            for(let team of array){
                team['members'].sort((a,b) => a.position - b.position);
            }
            this.teamMembers = array;
            this.defineTeamMembers()
        })
    }

    defineTeamMembers(){
        var chunkSize = (isBrowser() && window && typeof window != 'undefined' && window.innerWidth <= 767) ? 2 : 4
        for(let team of this.teamMembers){
            if(!team['chunkMembers'] || Math.max.apply(null, team['chunkMembers'].map(e=> e.length)) != chunkSize){
                team['chunkMembers'] = this.__chunk(team['members'], chunkSize)
            }
        }
    }

    checkDescription(membre, i, j, k){
        var link = null;
        if(membre.description){
            link = "#collapse"+i+'-'+j+'-'+k;
        }
        else{
            link = "";
        }
        return link;
    }


    // Timeline -----------------------------------------

    slidePrev(){
        if(isBrowser()){
            var swiper:any = document.querySelector('.swiper-container')
            swiper.swiper.slidePrev()
        }
    }

    slideNext(){
        if(isBrowser()){
            var swiper:any = document.querySelector('.swiper-container')
            swiper.swiper.slideNext()
        }
    }


    // Contact modal -----------------------------------------

    showModalContact(office=null){
        this.mapDotClicked = office
        if(isBrowser()) $('#contact-modal').modal('show')
    }

    hideModalContact(){
        if(isBrowser()) $('#contact-modal').modal('hide')
    }

    modalIsOpen(){
        return isBrowser() ? $('#contact-modal').is(':visible') : false
    }

    closeAllCollapses(){
        if(isBrowser()) $('.collapse').collapse('hide')
    }


    __chunk(arr,size){
        var newArray = JSON.parse(JSON.stringify(arr))
        return Array.from({ length: Math.ceil(newArray.length / size) }, (v, i) => newArray.slice(i * size, i * size + size) )
    }

    openChat(){
        if(isBrowser() && window && window['$chatwoot']){
            window['$chatwoot'].toggle("open");
        }
    }

}
